import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PostgrestFilterBuilder } from '@supabase/postgrest-js';
import { differenceInYears } from 'date-fns';
import { supabase } from '../../api';
type SalonTypes = {
    id?: string,
    created_at?: Date,
    bg_cover?: string,
    public_social_link?: string,
    type_of_expertise?: string,
    birthday?: Date,
    avatar?: string,
    first_name?: string,
    last_name?: string,
    username?: string,
    full_bio?: string,
    country?: string,
    state?: string,
    zip_code?: number,
    latitude?: number,
    longitude?: number,
    name?: string,
    website?: string,

}

export const updateSalon = async (profile: SalonTypes) => {
    if (profile.username) {
        const { data, error } = await supabase
            .from('salons_profile')
            .select('id')
            .eq('username', profile.username)
            .neq('id', profile.id);

        if (error) {
            throw new Error(error.message);
        }

        if (data.length) {
            throw new Error('Username already taken');
        }
    }
    // update birthday
    if (profile?.birthday) {
        const { data, error } = await supabase
            .from('allowed_ages')
            .select('min_age')
            .eq('country', profile?.country)
            .single();

        let minAge = !error && data?.min_age;
        if (!minAge) {
            const { data: defaultData } = await supabase
                .from('allowed_ages')
                .select('min_age')
                .eq('country', 'OTHER')
                .single();

            minAge = defaultData?.min_age;
        }

        const diff = differenceInYears(new Date(), new Date(profile?.birthday));
        if (diff < minAge) {
            throw Error(
                'Looks like you are not eligible for EyeBall... But thanks for reaching out!',
            );
        }
    }

    // update bd
    const requests: any[] = [];
    if (Object.keys(profile).some((k) => k !== 'id')) {
        requests.push(
            supabase.from('salons_profile').upsert(profile).eq('id', profile.id),
        );
    }

    if (requests.length) {
        const responses = await Promise.all(requests);
        const responsesError = responses.find((v) => v.error);

        if (responsesError) {
            throw new Error(responsesError.error?.message);
        }
    }

    const { data: newData, error: newError } = await supabase
        .from('salons_profile')
        .select(
            `
        *
      `,
        )
        .eq('id', profile.id)
        .single();

    if (newError) {
        throw new Error(newError.message);
    }

    const { data: session } = await supabase.auth.getSession();
    newData.isOwnProfile = session?.session?.user.id === profile.id;

    return newData;
};

export default function useUpdateSalon(salon: SalonTypes) {
    const queryClient = useQueryClient();

    return useMutation(
        (profileDetails: SalonTypes | void) => updateSalon(
            profileDetails
                ? { id: salon?.id || '', ...profileDetails }
                : salon || { id: '' },
        ),
        {
            onSuccess: (d) => {
                const { ...data } = d;
                queryClient.setQueryData(['profile', salon?.id], data);
            },
        },
    );
}